import { render } from "./EditPassHistoryTimeForm.vue?vue&type=template&id=16ae2c40"
import script from "./EditPassHistoryTimeForm.vue?vue&type=script&lang=js"
export * from "./EditPassHistoryTimeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__